export enum InputTypesEnums {
  DEFAULT = 'default',
  ROUNDED_FULL = 'rounded--full',
  ROUNDED_BORDER = 'rounded--border',
  DEFAULT_FILE = 'default--file',
  CIRCLE_FILE = 'circle--file',
}
